import {
    type AiAgentId,
    CONVERSATIONAL_MM_AGENT,
    SPROUT_AGENT,
} from '../constants/agents';
import {
    buildPersonaFromTestCase,
    CONVERSATIONAL_QA_TEST_CASES,
} from './conversationalQATestCases';
import {
    buildSproutPersonaFromTestCase,
    SPROUT_QA_TEST_CASES,
} from './sproutQATestCases';

export interface QASuiteCaseSnapshot {
    id: string;
    persona: string;
    fixtureId?: string;
    outcomeInstructions?: string;
}

const CASES_BY_AGENT: Record<AiAgentId, QASuiteCaseSnapshot[]> = {
    [SPROUT_AGENT.id]: SPROUT_QA_TEST_CASES.map((testCase) => ({
        id: testCase.id,
        persona: buildSproutPersonaFromTestCase(testCase),
        fixtureId: testCase.fixtureId,
        outcomeInstructions: testCase.expected,
    })),
    [CONVERSATIONAL_MM_AGENT.id]: CONVERSATIONAL_QA_TEST_CASES.map(
        (testCase) => ({
            id: testCase.id,
            persona: buildPersonaFromTestCase(testCase),
            outcomeInstructions: testCase.outcomeInstructions,
        }),
    ),
};

export const getQASuiteCaseSnapshots = (
    agentId: AiAgentId,
    caseIds?: string[],
): QASuiteCaseSnapshot[] | null => {
    const catalog = CASES_BY_AGENT[agentId];
    if (caseIds == null) {
        return catalog;
    }

    const casesById = new Map(
        catalog.map((testCase) => [testCase.id, testCase]),
    );
    const snapshots = caseIds.map((caseId) => casesById.get(caseId));
    if (snapshots.some((testCase) => testCase == null)) {
        return null;
    }

    return snapshots.filter(
        (testCase): testCase is QASuiteCaseSnapshot => testCase != null,
    );
};
